import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';
import DownTrend from '@/assets/icons/downTrendArrowIcon.svg?react';
import NoTrend from '@/assets/icons/noTrendArrowIcon.svg?react';
import UpTrend from '@/assets/icons/upTrendArrowIcon.svg?react';

export const ScoreTrendCont = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

interface IProgressArrowCont {
  theme: ITheme;
  mainColor: string;
  backgroundColor: string;
  isBorderless: boolean;
}

export const ScoreTrendContent = styled.div<IProgressArrowCont>`
  min-width: 2.75rem;
  width: fit-content;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ mainColor, backgroundColor, theme, isBorderless }: IProgressArrowCont) => `
    background: ${backgroundColor};
    color: ${mainColor};
    border: ${isBorderless ? 'none' : `1px solid ${mainColor}`};
    border-radius: ${theme.layout.spacing.nano};
    padding: ${theme.layout.spacing.nano};
  `}
`;

export const Sign = styled.span`
  ${({ theme }: IThemeProvider) => `
  margin: 0 ${theme.layout.spacing.nano};
  `}
`;

interface ITrendIcon {
  theme: ITheme;
  color: string;
}

export const UpTrendIcon = styled(UpTrend)<ITrendIcon>`
  path {
    ${({ color }: ITrendIcon) => `
      fill: ${color};
    `}
  }
`;

export const DownTrendIcon = styled(DownTrend)<ITrendIcon>`
  path {
    ${({ color }: ITrendIcon) => `
      fill: ${color};
    `}
  }
`;

export const NoTrendIcon = styled(NoTrend)<ITrendIcon>`
  path {
    ${({ color }: ITrendIcon) => `
      fill: ${color};
    `}
  }
`;
